export default {
  blogsView: {
    title: 'Blogues',
  },
  blogView: {
    label: {
      relatedArticles: 'En lire plus',
    },
  },
  blogCarousel: {
    cta: {
      readMore: 'En savoir plus',
      allProviders: 'Voir tous les Blogues producteurs',
    },
  },
  filters: {
    label: {
      selectedFilters: 'Filtres',
      all: 'Tout',
      headers: {
        typeOfBlog: 'Type de contenu',
        themes: 'Thèmes',
        authors: 'Auteurs',
      },
    },
    button: {
      cancel: 'Annuler',
      filter: 'Filtrer',
    },
    noRecordsFound: 'Aucun résultats trouvés',
  },
};
